export default __webpack_public_path__ + "static/media/smartband.07d7b2b4.png";